<script>
  export let user_name = "";
  export let user_email = "";
  export let user_phone = "";
  export let user_password = "";
  export let user_access_tier_id;
  export let user_status = "Active";
  let statuses = ["Active", "Inactive"];
  export let tiers;
  export let user_user_id = Math.floor(
    10000000 + Math.random() * 90000000
  ).toString();
  export let user_scenario_tries = 1;

  export let cancelHandler;
  export let saveHandler;

  setTimeout(()=>{
    console.log(`Generated user_id is ${user_user_id}`);
  }, 1000);

</script>

<div  class="w-full mt-4 pl-8">
  <!-- <div>
        <label for="email" class=" text-sm text-gray-800">Name</label>
        <input bind:value={name} type="email"
            class=" w-1/2 px-4 py-2 mt-2 text-red-700 bg-white border rounded-md focus:border-red-400 focus:ring-red-300 focus:outline-none focus:ring focus:ring-opacity-40">
        <label for="email" class="text-sm text-gray-800">Email</label>
        <input bind:value={email} type="email"
            class=" w-1/2 px-4 py-2 mt-2 text-red-700 bg-white border rounded-md focus:border-red-400 focus:ring-red-300 focus:outline-none focus:ring focus:ring-opacity-40">
    </div> -->

  <form class="w-full max-w-lg">
    <div class="flex flex-wrap -mx-3 mb-6">
      <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
        <label
          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          for="grid-first-name"
        >
          Name
        </label>
        <input
          bind:value={user_name}
          class="appearance-none block w-full bg-gray-200 text-gray-700 border  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="grid-first-name"
          type="text"
          placeholder="User Name"
        />
        <!-- <p class="text-red-500 text-xs italic">Please fill out this field.</p> -->
      </div>

      <div class="w-full md:w-1/2 px-3">
        <label
          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          for="grid-last-name"
        >
          Email
        </label>
        <input
          bind:value={user_email}
          class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          id="grid-last-name"
          type="text"
          placeholder="someone@somewhere.com"
        />
      </div>
      <div class="w-full md:w-1/2 px-3">
        <label
          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          for="grid-last-name"
        >
          Phone
        </label>
        <input
          bind:value={user_phone}
          class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          id="grid-last-name"
          type="text"
          placeholder="eg. 800-555-1212"
        />
      </div>
      <div class="w-full md:w-1/4 px-3">
        <label
          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          for="grid-last-name"
        >
          Scenario Tries
        </label>
        <input
          bind:value={user_scenario_tries}
          class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          id="grid-last-name"
          type="text"
          placeholder="1"
        />
      </div>
      
    </div>

    <div class="flex flex-wrap -mx-3 mb-6">
      <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0">
        <label
          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          for="grid-first-name"
        >
          Password
        </label>
        <input
          bind:value={user_password}
          class="appearance-none block w-full bg-gray-200 text-gray-700 border   rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="grid-first-name"
          type="text"
        />
        <!-- <p class="text-red-500 text-xs italic">Please fill out this field.</p> -->
      </div>
      <div class="w-full md:w-1/3 px-3">
        <label
          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          for="grid-state"
        >
          Access Tier
        </label>
        <div class="relative">
          <select
            bind:value={user_access_tier_id}
            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            id="grid-state"
          >
            {#each tiers as tier}
              <option value={tier.tier_id}>
                {tier.name}
              </option>
            {/each}
          </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            </div>
        
        </div>
      </div> 


      <div class="w-full md:w-1/3 px-3">
        <label
          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          for="grid-state"
        >
          Status
        </label>
        <div class="relative">
          <select
            bind:value={user_status}
            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            id="grid-state"
          >
            {#each statuses as st}
              <option value={st}>
                {st}
              </option>
            {/each}
          </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            </div>
        
        </div>
      </div> 
      
    </div>


    <div class="flex flex-wrap -mx-3 mb-6">
        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <button on:click|preventDefault={saveHandler} class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                Save User
              </button>

        </div>
        <div class="w-full md:w-1/2 px-3">
            <button on:click|preventDefault={cancelHandler} class="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded">
                Cancel
              </button>
        </div>      
      </div>
  
  

  </form>
</div>
